export default __webpack_public_path__ + "static/media/TrialBG.9fc817dd.jpg";